/********************************************************************************
 * Copyright (c) 2023 EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

.ghost-element {
    /* we are a true ghost so we do not want to be used as a target for any mouse event */
    pointer-events: none;
    opacity: 0.8;
}

.ghost-element.hidden {
    width: 0;
    height: 0;
    visibility: hidden;
}

.sprotty-node.insert-indicator:not(.selected) {
    pointer-events: none;
    fill: none;
    stroke: black; /* same color as default color for edges */
    stroke-width: 1.5px;
}
